<template>
  <div class="h-40">
    <el-input type="number" class="h-40 w-150" :placeholder="placeholder" v-model.number="range.from" :max="max" @blur="blur" @input="change"></el-input>
    <span>-</span>
    <el-input type="number" class="h-40 w-150" :placeholder="placeholder" v-model.number="range.to" :max="max" @blur="blur" @input="change"></el-input>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        default() {
          return {
            field: '',
            type: '',
            from: '',
            to: ''
          }
        }
      },
      placeholder: {
        type: String,
        default() {
          return ''
        }
      }
    },
    data() {
      return {
        range: {
          field: '',
          type: '',
          from: '',
          to: ''
        },
        max: 99999999999
      }
    },
    created() {
      this.range = this.value
    },
    methods: {
      blur() {
        if (this.range.to > this.max) {
          this.range.to = this.max
        }
        if (this.range.from > this.max) {
          this.range.from = this.max
        }
        if (this.range.to && this.range.from > this.range.to) {
          this.range.to = this.range.from
        }
      },
      change(value) {
        this.$emit('input', this.range)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// rangeFilter.vue?0867322b